module.exports = __webpack_public_path__ + "img/head_logo.ff99e35d.jpg";